import { BaseRouteService } from 'core/services';

class LoginRouteService extends BaseRouteService {
	constructor() {
		super();
		this.base = 'fulfillment-login';
	}

	login(resource) {
		return super.create(`${this.base}`, resource);
	}
}

export default LoginRouteService;



// WEBPACK FOOTER //
// ./src/common/data/route-services/LoginRouteService.js